import { useApiService, useTl } from "../../../../hooks";
import { useHistory, useParams } from "react-router";
import { useApiEffect } from "nsitools-react";
import React from "react";
import { ETLCodes } from "../../../../locales";
import { PageBase, BackButton, ProtectedTabs } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { Tab, Spinner, SpinnerSize } from "@blueprintjs/core";
import { BreedAllowedWorkbookTypePage } from "./BreedAllowedWorkbookTypePage";
import { BreedAllowedColorsPage } from "./BreedAllowedColors/BreedAllowedColorsPage";
import { BreedDetailPage } from "./BreedDetailPage";
import { BreedApi } from "../../../../api";
import { BreedClubPage } from "./BreedClubPage";
import { BreedJudgePage } from "./BreedJudgePage";
import { BreedVarietyListPage } from "./BreedVarieties/BreedVarietyListPage";
import { BreedExceptionListPage } from "./BreedExceptions/BreedExceptionsListPage";
import { useGlobalData } from "../../../../contexts";

export interface IBreedItemPageProps {}

export const BreedItemPage: React.FunctionComponent<IBreedItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const breedId = React.useMemo(() => +id, [id]);
  const history = useHistory();
  const { currentLanguage } = useGlobalData();
  const breedApi = useApiService(BreedApi);
  const [displayName, loading] = useApiEffect(
    () => breedApi.getDisplayName(breedId, currentLanguage.languageId),
    [breedId],
  );
  return (
    <>
      <PageBase
        breadCrumbs={[
          { text: t(ETLCodes.Breeds), route: ERoutes.breeds },
          { text: breedId > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
        ]}
      >
        <ProtectedTabs
          id="TabsBreed"
          onChange={(newTabId) => history.push(`${ERoutes.breeds}/${id}/${newTabId}/${state}`)}
          selectedTabId={tab}
          renderActiveTabPanelOnly
        >
          <BackButton backRoute={ERoutes.breeds} />
          <Tab
            id="detail"
            title={t(ETLCodes.Detail)}
            panel={<BreedDetailPage breedId={breedId} editMode={state === "edit"} />}
          />
          <Tab
            id="workbook"
            title={t(ETLCodes.WorkbookType)}
            panel={<BreedAllowedWorkbookTypePage breedId={breedId} editMode={state === "edit"} />}
            disabled={+id <= 0}
          />
          <Tab
            id="linkedColors"
            title={t(ETLCodes.LinkedColors)}
            panel={<BreedAllowedColorsPage editMode={state === "edit"} breedId={+id} />}
            disabled={+id <= 0}
          />
          <Tab id="judges" title={t(ETLCodes.Judges)} panel={<BreedJudgePage />} disabled={+id <= 0} />

          <Tab
            id="varieties"
            title={t(ETLCodes.Varieties)}
            disabled={+id <= 0}
            panel={<BreedVarietyListPage breedId={+id} editMode={state === "edit"} />}
          />
          <Tab
            id="exception"
            title={t(ETLCodes.Exception)}
            disabled={+id <= 0}
            panel={<BreedExceptionListPage breedId={+id} editMode={state === "edit"} />}
          />
          <Tab id="clubs" title={t(ETLCodes.Clubs)} disabled={+id <= 0} panel={<BreedClubPage />} />
          {/* <Tab id="breedCompatibility" title={t(ETLCodes.BreedCompatibility)} disabled={+id <= 0} /> */}
          {/* panel={<BreedCombatibilitySwitch />} */}
        </ProtectedTabs>
      </PageBase>
    </>
  );
};
